module.exports = __webpack_public_path__ + "img/ico_checkout_pay.99c5a17a.svg";